import { useContext } from "react";
import { useSelector } from "react-redux";
// import { FormContextMA } from "../form-context";
import {
  AllergicRhinitisDocTypes,
  MedicationReviewDocTypes,
} from "../../patient/clinical-services/service-steps/documentation/data";

export const Container = ({ children, className = "" }) => (
  <div className={`text-gray-800 box-border w-full max-w-[12.786667in] leading-[1.21] bg-white border-2 border-gray-300 rounded-lg ${className}`}>
    {children}
  </div>
);

export const Section = ({ children, className = "", formType }) => {
  // const { formType } = useContext(FormContextMA);

  if (
    [AllergicRhinitisDocTypes.InitialAssessment].includes(formType) ||
    [MedicationReviewDocTypes.PharmacistWorksheet].includes(formType)
  ) {
    return (
      <div
        className={`p-4 space-y-1 border-[1px] border-gray-200 bg-gray-10 rounded-[4px] gap-2.5 ${className}`}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={`px-4 py-2 space-y-1 border-x-[0.02084in] border-b-[0.02084in] first:border-t-[0.02084in] border-gray-200/50 first:rounded-t-[0.0416667in] last:rounded-b-[0.0416667in] ${className}`}
    >
      {children}
    </div>
  );
};

export const Divider = ({ className = "" }) => (
  <div className={`py-1`}>
    <div className={`w-full h-[1px] bg-gray-100 ${className}`} />
  </div>
);

export const H1 = ({ children, className = "" }) => (
  <h1 className={`font-bold text-[0.1885in] text-gray-800 whitespace-normal break-words break-all w-full max-w-full ${className}`}>
    {children}
  </h1>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-semibold pb-1 text-sm text-teal-300 ${className}`}>
    {children}
  </h2>
);

export const H3 = ({ children, className = "" }) => (
  <h3 className={`text-[0.125in] font-semibold ${className}`}>{children}</h3>
);

export const H4 = ({ children, className = "" }) => (
  <h3 className={`text-[0.156979in] font-medium ${className}`}>{children}</h3>
);

export const P = ({ children, className = "" }) => (
  <p className={`text-[0.125in] ${className}`}>{children}</p>
);

export const DataField = ({
  label,
  value,
  vertical = false,
  className,
  labelTeal = false,
  noWrapLabel = false,
  noWrapValue = false,
}) => (
  <dl
    className={`flex gap-1 ${
      vertical ? "flex-col" : "flex-row"
    } text-xs ${className}`}
  >
    {label && (
      <dt
        className={`${labelTeal && "text-REELTeal"} ${
          noWrapLabel && "whitespace-nowrap"
        }`}
      >
        {" "}
        {label || ""}
      </dt>
    )}
    <dd className={`font-semibold ${noWrapValue ? "whitespace-nowrap" : ""}`}>
      {value || ""}
    </dd>
  </dl>
);

export const DataField2 = ({
  label,
  value,
  vertical = false,
  className
}) => (
  <div
    className={`flex gap-2 ${
      vertical ? "flex-col" : "flex-row"
    } text-xs items-center ${className}`}
  >
    {label && <span className="text-black font-semibold">{label || ""}</span>}
    <div className="text-gray-800 flex-1 h-6 pl-2 pt-1 bg-gray-10 mr-2">{value || ""}</div>
  </div>
);

export const CheckInput = ({ checked = false, label = "", radio = false }) => (
  <div className="flex flex-row gap-[0.104167in] items-start">
    <div
      className={`flex items-center justify-center w-[0.145833in] h-[0.145833in] border ${
        checked ? "border-REELTeal bg-teal-50" : "border-gray-200 bg-white"
      } ${radio ? "rounded-full" : "rounded-[0.0416667in]"} ${
        checked ? "bg-teal-50" : "bg-white"
      }]`}
    >
      {!!checked && !radio && (
        <svg
          width="0.104167in"
          height="0.104167in"
          viewBox="0 0 12 10"
          style={{ marginVertical: "auto" }}
        >
          <path
            d="M1.5 5.25087L4.41892 8L10.5 1"
            stroke="#017E9D"
            strokeWidth={2}
            fill="none"
          />
        </svg>
      )}
      {!!checked && radio && (
        <div className="w-[0.0875in] h-[0.0875in] aspect-square bg-REELTeal rounded-full" />
      )}
    </div>
    <P>{label}</P>
  </div>
);

export const CheckList = ({ list = [] }) => {
  return (
    <div className="flex flex-col gap-1">
      {list.map((x, idx) => (
        <div key={x.id ?? x.label ?? idx} className="flex flex-row gap-[0.104167in] items-start">
          <div
            className={`flex items-center justify-center w-[0.145833in] h-[0.145833in] border ${
              x.checked
                ? "border-REELTeal bg-teal-50"
                : "border-gray-200 bg-white"
            } ${x.checked ? "bg-teal-50" : "bg-white"}]`}
          >
            {!!x.checked && (
              <svg
                width="0.104167in"
                height="0.104167in"
                viewBox="0 0 12 10"
                style={{ marginVertical: "auto" }}
              >
                <path
                  d="M1.5 5.25087L4.41892 8L10.5 1"
                  stroke="#017E9D"
                  strokeWidth={2}
                  fill="none"
                />
              </svg>
            )}
          </div>
          <div>
            <P>{x.label}</P>
          </div>
        </div>
      ))}
    </div>
  );
};

export const TealSubSection = ({ children, className = "", isBlue = true }) => (
  <div
    className={`p-[0.0833333in] border-[0.0104167in] rounded-[0.03125in] ${
      isBlue
        ? "border-teal-100 bg-teal-25 text-teal-300 "
        : "border-gray-400 bg-gray-20 text-gray-800"
    } ${className}`}
  >
    {children}
  </div>
);

export const CompliancyRequirements = ({ formType, pharmacyName }) => {
  const currentLoggedInUserDetail = useSelector((s) => s.users?.currentLoggedInUserDetail);
  const resolvedPharmacyName = pharmacyName || currentLoggedInUserDetail?.pharmacyName || "[name of pharmacy]";

  return (
    <Section formType={formType}>
      <H2>Compliancy Requirements</H2>
      <P>
        Pharmacist agrees to associate with {resolvedPharmacyName} when logging into healthcompassRx;
        <br /> and accept to comply with the Terms of Use and Privacy Policy to use the application in accordance with PHIPA and PIPEDA legislation.
      </P>
    </Section>
  );
};
